import styled from 'styled-components';

export const SectionHeading = styled.h3`
  margin: ${({ theme }) => theme.spacing(3, 0, 0.5)};
  font-size: ${({ theme }) => theme.typography.h5.fontSize};
  font-weight: ${({ theme }) => theme.typography.h5.fontWeight};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const OriginCaption = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ReadOnlyValue = styled.div`
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  color: ${({ theme }) => theme.palette.text.primary};
  overflow-wrap: anywhere;
`;
